module.exports = __webpack_public_path__ + "img/liveImg.c880cc86.png";